'use strict';

module Patersons {

    export interface ASXAnnouncementsScope extends ng.IScope {
        events: ASXAnnouncementsCtrl;
        hasData: boolean;
        isLoading: boolean;

        items: any[];
        filteredItems: any[];

        itemsPerPage: number;
        currentPage: number;
        totalItems: number;

        selectedCode: string;
        dateOptions: any;
        selectedDate: string;
    }
    export abstract class ASXAnnouncementsCtrl extends ResearchBaseCtrl {
        scope: Patersons.ASXAnnouncementsScope;
        morningStarService: Patersons.MorningStarService;

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'researchFeedService', 'navigationService', 'morningStarService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, researchFeedService, navigationService, morningStarService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;
            this.morningStarService = morningStarService;
            this.scope.hasData = false;
            this.scope.totalItems = 0;

            this.scope.selectedCode = "";
            this.scope.dateOptions = [
                {
                    key: "day1",
                    value: "Today"
                },{
                    key: "day2",
                    value: "Previous Day"
                },{
                    key: "week1",
                    value: "Past week"
                },{
                    key: "month1",
                    value: "Past Month"
                },{
                    key: "month3",
                    value: "Past 3 Months"
                },{
                    key: "month6",
                    value: "Past 6 Months"
                },{
                    key: "year1",
                    value: "Past Year"
                }
            ]
            this.scope.selectedDate = "day1";

            this.scope.itemsPerPage = 15;

            this.load(this.scope.selectedCode, this.scope.selectedDate, this.scope.currentPage);
        }
        onFilterChange = (key, value) => {
            this.scope[key] = value;
            let selectedCode = this.scope.selectedCode
            if(!selectedCode || selectedCode.length <= 5){
                this.load(selectedCode, this.scope.selectedDate, this.scope.currentPage);
            }
        }
        load(selectedCode, selectedDate, page) {
            this.scope.isLoading = true;
            this.morningStarService.getASXAnnouncements(selectedCode, selectedDate, page).then((data) => {
                this.scope.$apply(() => {
                    this.scope.hasData = true;
                    this.scope.isLoading = false;
                    if(data.document){
                        this.scope.items = [].concat(data.document);
                        if(this.scope.selectedDate === 'day2'){
                            //show only previous day items
                            
                        }
                    }else{
                        this.scope.items = [];
                    }
                    this.scope.totalItems = +data.resultstotal;

                });
            }) 
        }
    }
}
